import { useEffect } from "react";
import { GAME_SETTINGS_CHANGED } from "../local/gameSettings";
import { refreshAudioSettings, sfx, startMenuMusic, stopMenuMusic } from "../game/audio";

export function MenuMusic({ active }: { active: boolean }) {
  useEffect(() => {
    refreshAudioSettings();
    if (active) startMenuMusic();
    else stopMenuMusic();
    return () => {
      if (!active) stopMenuMusic();
    };
  }, [active]);

  useEffect(() => {
    const onSettings = () => {
      refreshAudioSettings();
      if (active) startMenuMusic();
    };
    window.addEventListener(GAME_SETTINGS_CHANGED, onSettings);
    return () => window.removeEventListener(GAME_SETTINGS_CHANGED, onSettings);
  }, [active]);

  useEffect(() => {
    if (!active) return;
    const onPointerUp = (event: PointerEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const control = target.closest("button, a, [role='button']");
      if (control) sfx.menu();
    };
    document.addEventListener("pointerup", onPointerUp, true);
    return () => document.removeEventListener("pointerup", onPointerUp, true);
  }, [active]);

  return null;
}
